module.exports = __webpack_public_path__ + "static/media/Brightly_ios_2.f17d16da.jpg";